import React from "react";
import styled from "styled-components";

const BudgetHome = (props) => {
    return (
        <WelcomeContainer>
            <MonikerLogo>MONIKER</MonikerLogo>
        </WelcomeContainer>
    )
}

export default BudgetHome;

const WelcomeContainer = styled.div`
    background: linear-gradient(135deg, #000000 0%, #1a1a1a 100%);
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const MonikerLogo = styled.h1`
    font-size: 6rem;
    font-weight: 900;
    color: #fdb506;
    letter-spacing: 20px;
    margin: 0;
    text-shadow: 0 4px 16px rgba(253, 181, 6, 0.5);
    font-family: 'Arial Black', sans-serif;
    animation: fadeIn 1s ease-in;

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: scale(0.95);
        }
        to {
            opacity: 1;
            transform: scale(1);
        }
    }

    @media (max-width: 768px) {
        font-size: 3rem;
        letter-spacing: 8px;
    }
`;